import { render, staticRenderFns } from "./MatrizRfmRecencia.vue?vue&type=template&id=d817da48&"
import script from "./MatrizRfmRecencia.vue?vue&type=script&lang=js&"
export * from "./MatrizRfmRecencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports